export default {
  SET_PAGINA_ESTACIONAMENTO(state, pagina) {
    state.estacionamento = pagina
  },
  SET_PAGINA_FILAESPERA(state, pagina) {
    state.filaEspera = pagina
  },
  SET_PAGINA_AREAPET(state, pagina) {
    state.areaPet = pagina
  },
  SET_PAGINA_FORMASPAG(state, pagina) {
    state.formasPag = pagina
  },
  SET_PAGINA_HAPPYPROMO(state, pagina) {
    state.happyPromo = pagina
  }
}